import { Box, styled } from '@mui/material';
import Background from 'images/banners/background.png';
import HeaderBG from 'images/banners/header.png';

export const DesktopHeaderWrapper = styled(Box)(({ theme }) => ({
  width              : '100%',
  height             : '116px',
  padding            : '14px 78px',
  display            : 'flex',
  justifyContent     : 'space-between',
  alignItems         : 'center',
  boxSizing          : 'border-box',
  position           : 'relative',
  background         : `url(${Background})`,
  backgroundRepeat   : 'no-repeat',
  backgroundPosition : 'center',
  backgroundColor    : theme.palette.primary.white,
  backgroundSize     : 'cover',
  borderBottom       : '1px solid #E9E9E9',
}));

export const MobileHeaderWrapper = styled(Box)(({ theme }) => ({
  width              : '100%',
  height             : '71px',
  padding            : '14px 10px',
  display            : 'flex',
  justifyContent     : 'space-between',
  alignItems         : 'center',
  boxSizing          : 'border-box',
  position           : 'relative',
  background         : `url(${HeaderBG})`,
  backgroundRepeat   : 'no-repeat',
  backgroundPosition : 'center',
  backgroundColor    : theme.palette.primary.white,
  backgroundSize     : 'cover',
  borderBottom       : '1px solid #E9E9E9',
}));
